// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"826":"user-rights-roles","893":"login-home-welcome"}[chunkId] || chunkId) + "." + {"346":"4bd780c3","826":"d7e4dc2f","893":"8941d67f"}[chunkId] + ".js";
};